import { ReactNode } from 'react';
import styles from './DialogPageContent.module.scss';

interface Props {
  children: ReactNode;
}

// The content of a dialog page, stacked vertically.
export function DialogPageContent(props: Props) {
  return <div className={styles['root']}>{props.children}</div>;
}
